<template>
  <div
    class="jl-query-button-div jl-unified-filter-header"
    :class="{
      'is-collapsed': !expanded,
      'is-embedded': embedded,
      'has-extra': $slots.default
    }"
  >
    <div class="jl-filter-heading">
      <span class="jl-filter-section-icon">
        <i class="el-icon-search"></i>
      </span>
      <span class="custom-span">筛选搜索</span>
    </div>

    <div v-if="$slots.default" class="jl-filter-header-extra">
      <slot></slot>
    </div>

    <button
      type="button"
      class="jl-filter-toggle"
      :aria-expanded="String(expanded)"
      @click="toggleFilter"
    >
      {{ expanded ? '收起筛选' : '展开筛选' }}
      <i :class="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'JlFilterHeader',
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      internalExpanded: true,
      originalDisplay: ''
    }
  },
  computed: {
    expanded() {
      return typeof this.value === 'boolean' ? this.value : this.internalExpanded
    }
  },
  mounted() {
    const filterBody = this.getFilterBody()
    if (filterBody) {
      this.originalDisplay = filterBody.style.display
      filterBody.setAttribute('aria-hidden', 'false')
    }
  },
  beforeDestroy() {
    if (typeof this.value === 'boolean') return
    const filterBody = this.getFilterBody()
    if (filterBody) {
      filterBody.style.display = this.originalDisplay
      filterBody.removeAttribute('aria-hidden')
    }
  },
  methods: {
    getFilterBody() {
      return this.$el && this.$el.nextElementSibling
    },
    toggleFilter() {
      const nextExpanded = !this.expanded
      if (typeof this.value === 'boolean') {
        this.$emit('input', nextExpanded)
        return
      }
      const filterBody = this.getFilterBody()
      this.internalExpanded = nextExpanded
      if (filterBody) {
        filterBody.style.display = nextExpanded ? this.originalDisplay : 'none'
        filterBody.setAttribute('aria-hidden', String(!nextExpanded))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JlFilterHeader/index.vue